/**
 * Human-readable labels for each backend-emitted salt category key.
 * Shared between:
 *   - Deck-level Salt pane (SaltBreakdown)
 *   - Card-level CardInfoDialog vitals
 * so the vocabulary stays consistent wherever category names surface.
 */
export const SALT_CATEGORY_SHORT_LABELS = {
    mld: 'MLD',
    boardwipes: 'Wipes',
    taxes: 'Taxes',
    cedhMetashare: 'cEDH',
    powergamer: 'cEDH',
    sacrifice: 'Sac',
    reserved: 'Reserved',
    cantActivate: 'Can\u2019t activate',
    cantAttack: 'Can\u2019t attack',
    cantCast: 'Can\u2019t cast',
    cantDraw: 'Can\u2019t draw',
    cantEven: 'Can\u2019t even',
    cantGainLife: 'Can\u2019t gain life',
    cantSearch: 'Can\u2019t search',
    cantTrigger: 'Can\u2019t trigger',
    cantUntap: 'Can\u2019t untap',
    cant: 'Can\u2019t\u2026?',
    infiniteCombos: 'Combos',
    edhrec: 'EDHRec',
    theft: 'Theft',
    extraCombats: 'Extra combats',
    extraTurns: 'Extra turns',
    wheels: 'Wheels',
    offColorFetches: 'Off-color fetches',
    cardPrice: '$ Price',
    payTheOne: 'Pay the\u2026?',
    discard: 'Discard',
    poison: 'Poison',
    chaos: 'Chaos',
    groupSlug: 'Group slug',
    annihilator: 'Annihilator',
    locks: 'Locks',
};

export function prettySaltCategory(cat) {
    return SALT_CATEGORY_SHORT_LABELS[cat] || cat;
}
